import { useNavigate, Link } from 'react-router-dom'
import { useCreateBankMutation } from '../../Redux/Service/BankApi'
import { toast } from 'react-toastify'
import StyledDashboardLayout from '../style'
import BankForm from './BankForm'
import { handleApiError } from '../../utils/apiErrorHandler'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

function BankAdd() {
   const navigate = useNavigate()
   const [createBank] = useCreateBankMutation()

   const handleSubmit = async (values, { setSubmitting }) => {
      try {
         const payload = {
            bank_name: values.bank_name.trim(),
            account_no: values.account_no.trim(),
            account_type: values.account_type?.trim() || null,
            other_fields: (values.other_fields || []).map((item) => ({
               label: item.label.trim(),
               value: item.value.trim(),
            })),
         }
         const res = await createBank(payload).unwrap()
         toast.success(res.message)
         navigate('/bank')
      } catch (error) {
         handleApiError(error)
      } finally {
         setSubmitting(false)
      }
   }

   return (
      <StyledDashboardLayout>
         <div className="content-wrapper">
            <div className="content-header d-flex justify-content-between m-3">
               <h1>Add Bank Account</h1>
               <Link to="/bank" className="btn addBtn">
                  <ArrowBackIcon /> Back
               </Link>
            </div>
            <div className="card customCard p-3 m-3">
               <BankForm
                  initialValues={{
                     bank_name: '',
                     account_no: '',
                     account_type: '',
                     other_fields: [],
                  }}
                  onSubmit={handleSubmit}
                  submitLabel="Create"
               />
            </div>
         </div>
      </StyledDashboardLayout>
   )
}

export default BankAdd
